import React, { Component } from 'react'
import Dummy from '../../../assets/image/event/corpu/corpu_cover.jpg'
import event2 from '../../../assets/image/event2.jpg'
import Chevron from '../../../assets/image/chevron-white.png'
import './style.css'
import {Button} from '@material-ui/core'
import Download from '../../../assets/image/Download.svg'
import Skeleton from 'react-loading-skeleton'
import NoImage from '../../../assets/image/no_image.png'
import moment from 'moment'
import { MuiThemeProvider, createMuiTheme,withStyles, } from '@material-ui/core/styles'
const themeButton = createMuiTheme({ 
    palette: { 
        primary: {
            main:'#FFFFFF',
        },
    } 
})
export default class banner2 extends Component {
    render() {
    const {event,loading}=this.props
        
        return (
            <div>
                <div className='banner2-wrapper-desktop'>
                    <img src={event2}/>
                    <div className='banner-content'>
                        {event!==null&&
                        <div className='event-breadchrum'>
                             <p><a href="#" onClick={()=>window.location.assign('/event-list')}>Event & webinar</a></p>
                            &nbsp;
                            <img src={Chevron} className='breadchrum-chevron'/>
                            &nbsp;
                            <p>{event.event.title}</p>
                            
                        </div>
                        }
                        <div className='banner2-content-thumbnail'>
                            <img src={event.thumbnail.url!==null?event.thumbnail.url:NoImage}/>
                        </div>
                        <div className='banner2-content-description'>
                             
                            <>
                            <h1>{event.event.title}</h1>
                            <p>{event.category.text}&nbsp;&nbsp; |&nbsp;&nbsp; Date {event.event.fromDate===event.event.toDate?moment(event.event.fromDate).format('D MMM YYYY'):`${moment(event.event.fromDate).format('D MMM')} - ${moment(event.event.toDate).format('D MMM YYYY')}`} {event.event.address}</p>
                            </>
                        </div>
                        
                    </div>
                   
                </div>
                {event.speakers.length>0&&
                <div className='banner2-content-speaker'>
                    
                    <>
                    <h3 >Speaker</h3>
                    {/* <br/> */}
                    <div style={{display:'grid',gridTemplateColumns:'repeat( auto-fit,minmax(15rem,1fr))',gridRowGap:20}}>
                    {event.speakers.map((data,i)=>(
                        <> 
                        <div className='speaker'>
                            <div className='speaker-bullets'></div>
                            &nbsp;&nbsp;
                            <p>{data.name}<br/>{data.title} {data.company}</p>
                        </div>
                        </>
                    ))} 
                    </div>
                    </>
                </div>
                }
                <div>
                
                <div className='webinar-mobile'>
                <div className='webinar-overlay-mobile'>
                    <img src={event2} className='show-mobile'/>
                    <div className='webinar-caption-mobile'>
                        <div className='breadcrum-event-webinar'>
                            <p><a href="#" onClick={()=>window.location.assign('/event-list')}>Event & webinar</a></p>
                            &nbsp;
                            <img src={Chevron}  className='breadcrum-chevron-event-webinar'/>
                            &nbsp;
                            <p>{event.event.title.substring(0,30)}</p>
                        </div>
                        <div>
                            <h1>{event.event.title}</h1>
                            <br/>
                            <p style={{color:'white'}}>{event.category.text} {event.event.fromDate===event.event.toDate?moment(event.event.fromDate).format('D MMM YYYY'):`${moment(event.event.fromDate).format('D MMM')} - ${moment(event.event.toDate).format('D MMM YYYY')}`} {event.event.address}</p>
                        </div>
                    </div>
                </div>
                <br/>
                {event.speakers.length>0&&
                <div className='webinar-speaker-mobile'>
                    <h3 >Speaker</h3>
                    <br/>
                    <div style={{display:'grid'}}>
                    {event.speakers.map((data,i)=>(
                        <>
                        <div className='speaker-mobile'>
                            <div className='speaker-bullets-mobile'></div>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <p className='speaker-name-mobile'>{data.name}<br/>{data.title} {data.company}</p>
                        </div>
                        <br/>
                        </>
                    ))} 
                    </div>
                </div>
                } 
                </div>
            </div>
            </div>
        )
    }
}
